var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ closeBar: _vm.opened }},[_c('m-header'),_c('div',{staticClass:"wrapper_con"},[_c('side-bar'),_c('page-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }